import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromConfigurationStore from '@appStore/configuration';
import * as fromAccountStore from '@appStore/account';
import { PermissionType } from '@enums';
import { timeout, filter, map, catchError } from 'rxjs/operators';
import { SxCookieService } from '@services';
import { CookieAttributes } from 'es-cookie/src/CookieAttributes';
import * as sxUtil from '../../utils/sx-utilities';

@Injectable()
export class PermissionGuard  {
  constructor(
    private store: Store<fromConfigurationStore.State>,
    private accountStore: Store<fromAccountStore.State>,
    private sxCookieService: SxCookieService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(fromConfigurationStore.getPermissionsWithLoaded)
    .pipe(
      timeout(6000),
      filter(x => x.loaded),
      map(store => {
        if (store.permissions.some(permission => permission.name === PermissionType.View)) {
          return true;
        } 
        
        this.accountStore
        .select(fromAccountStore.getUserIsLogingIn)
          .pipe(
            filter(x => !x)
          ).subscribe(isLogingIn => {
            this.router.navigate(['/unauthorized']);
          });

        return false;
      }),
      catchError(timeoutError => {
        this.store.dispatch(new fromConfigurationStore.LoadPermission());
        return this.store.select(fromAccountStore.getUserType).pipe(
          map(userType => {
            this.setDeeplinkCookie(state.url);
            this.router.navigate(['/login/auto/' + sxUtil.getClientIdFromUserType(userType)]);
            return false;
          })
        );
      })
    );
  }

  private setDeeplinkCookie(deeplink: string) {
    let expiration = new Date();
    expiration.setMinutes(new Date().getMinutes() + 5);
    this.sxCookieService.setCookie('SX_DEEPLINK', deeplink, { expires: expiration } as CookieAttributes);
  }
}
